import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FeatureTypeService} from '@catcore/services';
import {Feature} from '@catcore/services/feature/feature';
import {ExplorerItem, TreeNodeInfo} from '@catui/types';
import {Store} from '@ngrx/store';
import {isNullOrUndefined} from 'util';
import {Subscription} from "rxjs";

@Component({
  templateUrl: './feature-list.component.html',
  styleUrls: ['./feature-list.component.scss'],
})
export class FeatureListComponent implements OnInit, OnDestroy {
  explorerItems = [];
  doAllowCreate = true;
  currentSelectedFeatureItem: ExplorerItem = null;

  featureListSubscription: Subscription = null;

  private features: Feature[];

  constructor(private route: ActivatedRoute,
              private featureTypeService: FeatureTypeService,
              private router: Router,
              private store: Store<any>) {
  }

  ngOnInit() {
    this.route.data.subscribe((resolved) => {
      this.features = resolved.featureTypes;
      this.updateExplorerItems(this.features);
    });

    this.store
      .select((state) => state.core.feature.created)
      .subscribe((createdFeature) => {
        if (createdFeature) {
          this.refreshList();
        }
      });

    this.store
      .select((state) => state.core.feature.deleted)
      .subscribe(() => {
        this.refreshList();
      });

    this.featureTypeService
      .getCurrent()
      .subscribe((feature: Feature) => {
        if (!isNullOrUndefined(feature)) {
          this.updateCurrentSelected(feature);
        } else {
          this.resetCurrent();
        }
      });
  }

  ngOnDestroy() {
    if (this.featureListSubscription) {
      this.featureListSubscription.unsubscribe();
    }
    this.featureTypeService.resetCurrent();
    this.resetCurrent();
  }

  onActivateItem(nodeInfo: TreeNodeInfo) {
    this.router.navigate(['features', nodeInfo.item.value.id, 'properties']);
  }

  onAddOrCreate() {
    this.resetCurrent();
    this.router.navigate(['features']);
  }

  hasAdditionalInfo(feature: Feature) {
    return this.hasVariantId(feature);
  }

  hasVariantId(feature: Feature): boolean {
    return !isNullOrUndefined(feature.variant_id);
  }

  getVariantId(feature: Feature): string {
    return feature.variant_id;
  }

  getDescription(feature: Feature): string {
    return feature.description;
  }

  /**
   * Filter the current list of ExplorerItem to equal the received value
   *
   * @param value
   */
  doFilterItems(value) {
    let filteredFeatures = this.features;
    let isValidSearchTerm = !isNullOrUndefined(value);
    isValidSearchTerm = isValidSearchTerm && value.trim().length > 0;

    if (isValidSearchTerm) {
      const searchTerm = value.toLowerCase();
      filteredFeatures = this.features.filter((feature) => {
        const equalsName = feature.name.toLowerCase().search(searchTerm) >= 0;
        const equalsVariantId = !isNullOrUndefined(feature.variant_id) && feature.variant_id.toLowerCase().search(searchTerm) >= 0;
        const equalsDescription = !isNullOrUndefined(feature.description) && feature.description.toLowerCase().search(searchTerm) >= 0;
        if (equalsName || equalsVariantId || equalsDescription) {
          return feature;
        }
      });
    }
    this.updateExplorerItems(filteredFeatures);
  }

  /**
   * React to the current state of the searchbox container
   * @param {boolean} isActive
   */
  handleSearchBox(isActive: boolean) {
    if (!isActive) {
      this.updateExplorerItems(this.features);
    }
  }

  private resetCurrent() {
    this.currentSelectedFeatureItem = {value: null, label: null, expanded: false, allowedActions: []};
  }

  private updateCurrentSelected(feature: Feature) {
    const filtered: ExplorerItem[] = this.explorerItems
      .filter((item: ExplorerItem) => item.value.id === feature.id);
    if (filtered.length !== 1) {
      console.error('Index out of bounce for filtered items', filtered);
    } else {
      this.currentSelectedFeatureItem = filtered.pop();
    }
  }

  private refreshList() {
    if (this.featureListSubscription) {
      this.featureListSubscription.unsubscribe();
    }
    this.featureListSubscription = this.featureTypeService
      .getAll()
      .subscribe((features: Feature[]) => {
        this.features = features;
        this.updateExplorerItems(features);
      });
  }

  private updateExplorerItems(items: Feature[]): void {
    const explorerItems: ExplorerItem[] = [];
    items.forEach((item) => {
      explorerItems.push({label: item.name, value: item, expanded: false, allowedActions: []});
    });
    this.explorerItems = explorerItems;
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/features/components/feature-list/feature-list.component.ts